import React from "react";
import { useSearchParams } from "react-router-dom";

import { FilterStore } from "stores";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

const Indicator: React.FC = (): JSX.Element | null => {
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    state: { filter, indicator },
    dispatch,
  } = React.useContext(FilterStore);

  const dispatchFilterAndLink = ({ type, payload }: any) => {
    switch (type) {
      case "UPDATE_FILTER": {
        const [[type, newValue]] = Object.entries(payload);
        if (Array.isArray(newValue)) {
          if (newValue.length === 0) {
            searchParams.delete(type);
          } else {
            searchParams.set(type, newValue.toString());
          }
        } else if (newValue === null) {
          searchParams.delete(type);
        }
        setSearchParams(searchParams);
        dispatch({
          type: "UPDATE_FILTER",
          payload: { [type]: newValue },
        });
        break;
      }
      case "REMOVE_ID_FROM_FILTER": {
        const [[type, newValue]] = Object.entries(payload);
        const { filter: targetFilter, id: idToRemove } = payload;

        let newFilter = filter[targetFilter].filter(
          (id: any) => id !== idToRemove,
        );

        if (Array.isArray(newFilter)) {
          if (newFilter.length === 0) {
            searchParams.delete(targetFilter);
          } else {
            searchParams.set(targetFilter, newFilter.toString());
          }
        } else if (newValue === null) {
          searchParams.delete(type);
        }
        setSearchParams(searchParams);
        dispatch({
          type: "UPDATE_FILTER",
          payload: { [targetFilter]: newFilter },
        });
        break;
      }
    }
  };

  return (
    <Stack
      id="carbando-page-catalog-indicator-root"
      direction="row"
      sx={{ flexWrap: "wrap", maxWidth: "100%", gap: 1 }}
    >
      {Array.from(indicator, ([key, f]: [string | number, any]) =>
        f({ filter: filter[key], dispatch: dispatchFilterAndLink }),
      )}
    </Stack>
  );
};

export default Indicator;
